import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const propTypes = {
  clearRequestPending: PropTypes.bool,
  error: PropTypes.string,
  isOpen: PropTypes.bool,
  handleClearAlertClick: PropTypes.func,
  provisionName: PropTypes.string,
  toggleModal: PropTypes.func,
};

const defaultProps = {
  clearRequestPending: null,
  error: '',
  isOpen: null,
  handleClearAlertClick: () => {},
  provisionName: '',
  toggleModal: () => {},
};

const ClearAlertModal = ({
  clearRequestPending,
  isOpen,
  toggleModal,
  error,
  handleClearAlertClick,
}) => {
  return (
    <Modal
      centered
      contentClassName="rounded-lg"
      isOpen={isOpen}
      toggle={toggleModal}
    >
      <ModalHeader toggle={toggleModal} className="border-bottom-0">
        <p className="font-weight-normal">Clear Alert?</p>
      </ModalHeader>
      <ModalBody className="d-flex flex-column pt-0 font-weight-light description-text text-muted">
        <p>
          Once cleared, this alert will return back to an inactive state until
          it is triggered again.
        </p>
        <p className="pb-4">Are you sure?</p>
        {error && <span className="text-danger">{error}</span>}
      </ModalBody>
      <ModalFooter className="justify-content-between justify-content-md-end border-top-0">
        <button
          className="btn btn-sm btn-outline-secondary ml-md-4 px-4 py-0 nine-tenth-text"
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          className="btn modal-button-submit px-3 py-0 nine-tenth-text text-nowrap"
          onClick={handleClearAlertClick}
        >
          {clearRequestPending ? (
            <FontAwesomeIcon
              icon={faCircleNotch}
              spin
              size="lg"
              className="m-1"
            />
          ) : (
            'Clear Alert'
          )}
        </button>
      </ModalFooter>
      <style jsx>{`
        .description-text {
          font-size: 0.75rem;
        }
        @media (min-width: 768px) {
          .description-text {
            font-size: 1rem;
          }
        }
      `}</style>
    </Modal>
  );
};
ClearAlertModal.propTypes = propTypes;
ClearAlertModal.defaultProps = defaultProps;

export default memo(ClearAlertModal);
